import { defineComponent as _defineComponent } from 'vue';
import { cn } from '../../primitives/utils';
import { Input } from '../../primitives/input';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SidebarInput',
    props: {
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const __returned__ = { props, get cn() { return cn; }, get Input() { return Input; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
